module.exports = __webpack_public_path__ + "static/media/need_help.a526f1ac.svg";